import { SVGFC } from '@repo/toolkit/types'

const EnglishIcon: SVGFC = (props) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_21066_833952)">
        <path
          d="M14 24.3864C19.7353 24.3864 24.3846 19.7371 24.3846 14.0018C24.3846 8.26654 19.7353 3.61719 14 3.61719C8.26474 3.61719 3.61539 8.26654 3.61539 14.0018C3.61539 19.7371 8.26474 24.3864 14 24.3864Z"
          fill="#346DA6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.4649 7.98479C22.1284 7.51232 21.7534 7.06922 21.3444 6.66009L21.3419 6.65758C20.9328 6.24858 20.4897 5.87356 20.0172 5.53711L5.53537 20.0189C5.87182 20.4914 6.24685 20.9345 6.65584 21.3436L6.65835 21.3462C7.06748 21.7551 7.51058 22.1302 7.98305 22.4666L22.4649 7.98479Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.0172 22.4666C20.4897 22.1302 20.9328 21.7551 21.3419 21.3462L21.3444 21.3436C21.7534 20.9345 22.1284 20.4914 22.4649 20.0189L7.98305 5.53711C7.51058 5.87356 7.06748 6.24858 6.65835 6.65758L6.65584 6.66009C6.24685 7.06922 5.87182 7.51232 5.53537 7.98479L20.0172 22.4666Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.1097 20.489C21.8687 20.79 21.6112 21.0774 21.3386 21.3496L14.0461 14.0571L14.8619 13.2412L22.1097 20.489Z"
          fill="#CA4638"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.51334 22.1094C7.2123 21.8683 6.92497 21.6108 6.65271 21.3382L14.5222 13.4688L15.3381 14.2846L7.51334 22.1094Z"
          fill="#CA4638"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.486 5.89213C20.7871 6.13322 21.0744 6.39072 21.3467 6.66329L14.631 13.3789L13.8152 12.563L20.486 5.89213Z"
          fill="#CA4638"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.88977 7.51481C6.13086 7.21377 6.38836 6.92644 6.66092 6.65418L13.2612 13.2544L12.4453 14.0703L5.88977 7.51481Z"
          fill="#CA4638"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.2409 15.733C24.3354 15.1702 24.3845 14.5919 24.3845 14.0023C24.3845 13.4126 24.3354 12.8343 24.2409 12.2715H3.75888C3.66445 12.8343 3.6153 13.4126 3.6153 14.0023C3.6153 14.5919 3.66445 15.1702 3.75888 15.733H24.2409Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.7308 24.2428C15.1679 24.3373 14.5897 24.3864 14 24.3864C13.4103 24.3864 12.8321 24.3373 12.2692 24.2428V3.76077C12.8321 3.66634 13.4103 3.61719 14 3.61719C14.5897 3.61719 15.1679 3.66634 15.7308 3.76077V24.2428Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.3211 15.1553C24.363 14.7765 24.3845 14.3915 24.3845 14.0015C24.3845 13.6115 24.363 13.2265 24.3211 12.8477H3.67867C3.6368 13.2265 3.6153 13.6115 3.6153 14.0015C3.6153 14.3915 3.6368 14.7765 3.67867 15.1553H24.3211Z"
          fill="#CA4638"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.1539 24.323C14.7751 24.3649 14.3901 24.3864 14.0001 24.3864C13.6101 24.3864 13.2251 24.3649 12.8463 24.323V3.68057C13.2251 3.63869 13.6101 3.61719 14.0001 3.61719C14.3901 3.61719 14.7751 3.63869 15.1539 3.68057V24.323Z"
          fill="#CA4638"
        />
      </g>
      <defs>
        <clipPath id="clip0_21066_833952">
          <rect width="21" height="21" fill="white" transform="translate(3.5 3.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default EnglishIcon
